import { render, staticRenderFns } from "./fpTabContent.vue?vue&type=template&id=c871b9bc"
import script from "./fpTabContent.vue?vue&type=script&lang=js"
export * from "./fpTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports